import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiwMatSelectFilterComponent } from './serviw-mat-select-filter/serviw-mat-select-filter.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    ServiwMatSelectFilterComponent
  ],
  exports: [
    ServiwMatSelectFilterComponent
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    MatButtonModule,
    MatCardModule
  ]
})
export class ShareModule { }
